/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * A schema for a ClaimsSchema.
 */
export interface ClaimsSchema {
    /** A list of claim definitions. */
    fields: Truvity.ClaimsSchemaFieldsItem[];
    /** The base IRI of the JSON-LD context that will be used to resolve semantics of the child claims. */
    jsonLdBaseIri?: string;
    /** [DEPRECATED] The IRI of the JSON-LD context that will be used to generate the vocabulary. */
    jsonLdIri?: string;
    /** The delimiter used to construct the IRI of a term based on the context base IRI and term name. If omitted, the default value of `#` will be used. */
    jsonLdRelativeIriDelimiter?: string;
    /** The JSON-LD term name that will be used to define semantics of the structure. */
    jsonLdTermName?: string;
}
